/**
 * 「回到登入頁時要顯示的一句說明」（例如改完密碼被登出）。
 *
 * 為什麼不用 `navigate("/login", { state })` 帶過去：登出會讓 `RequireAuth`
 * 立刻 render 出 `<Navigate to="/login" state={{ from }}>`，而 data router 的
 * 導頁走 transition、優先序比 session 狀態的更新低 —— 實測是 `RequireAuth`
 * 那一次導頁後到、把我們帶的 state 整個蓋掉，提示從來沒出現過。所以改成登出
 * 前先把訊息放在這裡，由登入頁自己來拿，跟導頁的先後順序無關。
 *
 * 只放記憶體：重新整理就不見正是想要的，這不是要保留的狀態。
 */
let pending: string | null = null;

export function setLoginNotice(message: string) {
  pending = message;
}

/** 只讀不清：StrictMode 會把 useState 的初始化函式呼叫兩次，讀了就清會讓第二次拿到 null */
export function peekLoginNotice(): string | null {
  return pending;
}

export function clearLoginNotice() {
  pending = null;
}
